import React from 'react';
import './TranscriptView.css';

export const TranscriptView = ({ transcript, evaluation }) => {
  return (
    <div className="transcript-view">
      <h3>Your Answer</h3>
      <div className="transcript-text">
        {transcript}
      </div>

      {evaluation && (
        <div className="evaluation">
          <h4>Evaluation</h4>
          <div className="scores">
            <div className="score-item">
              <span className="score-label">Overall Score:</span>
              <span className="score-value">{evaluation.score || 'N/A'}/10</span>
            </div>
            {evaluation.technical_score && (
              <div className="score-item">
                <span className="score-label">Technical:</span>
                <span className="score-value">{evaluation.technical_score}/10</span>
              </div>
            )}
            {evaluation.communication_score && (
              <div className="score-item">
                <span className="score-label">Communication:</span>
                <span className="score-value">{evaluation.communication_score}/10</span>
              </div>
            )}
          </div>

          {evaluation.feedback && (
            <div className="feedback">
              <strong>Feedback:</strong>
              <p>{evaluation.feedback}</p>
            </div>
          )}

          {evaluation.strengths && evaluation.strengths.length > 0 && (
            <div className="strengths">
              <strong>Strengths:</strong>
              <ul>
                {evaluation.strengths.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </div>
          )}

          {evaluation.weaknesses && evaluation.weaknesses.length > 0 && (
            <div className="weaknesses">
              <strong>Areas for Improvement:</strong>
              <ul>
                {evaluation.weaknesses.map((w, i) => (
                  <li key={i}>{w}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

